import { useCallback } from 'react';
import { useOpenEventPanel } from '../../event-panel/use-open-event-panel';
import { useOpenFrEventDetails } from '../../fr-event-details-page/hooks/use-open-fr-event-details';
import { FrEventDetailsTab } from '../../fr-event-details-page/types';
import { useApplicationType } from './use-application-type';

export function useOpenEvent() {
    const { isFirstResponder } = useApplicationType();
    const openFrEventDetails = useOpenFrEventDetails();
    const openEventPanel = useOpenEventPanel();

    return useCallback(
        ({
            eventId,
            frEventDetailsTabName,
            locationState,
            shouldFocusOnCadEventPanel,
        }: {
            eventId: number | undefined;
            frEventDetailsTabName: FrEventDetailsTab;
            locationState?: Record<string, unknown>;
            shouldFocusOnCadEventPanel?: boolean;
        }) => {
            if (isFirstResponder) {
                openFrEventDetails(eventId, frEventDetailsTabName, locationState);
            } else {
                openEventPanel({
                    eventId,
                    shouldFocusPanel: shouldFocusOnCadEventPanel,
                });
            }
        },
        [isFirstResponder, openEventPanel, openFrEventDetails]
    );
}
